<template>
    <v-dialog v-model="modalShow" persistent max-width="60%" scrollable>
      <v-card >
        <v-card-title class="pt-2 px-3">
          <v-col class="text-end pa-0" cols="12">
            <v-btn icon dark @click="showClose()">
              <v-icon color="primary">mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col v-show="showForm" class="text-center py-0" cols="12">
            <h1 class="mb-0" style="font-size: 22px">Adicionar nota fiscal</h1>
            <p class="mb-0"  style="font-size:14px;">
              Informe o dados de nota fiscal a ser associada ao(s) lote(s).
            </p>
          </v-col>
          <v-row>
            <v-col v-show="!showForm" class="text-left px-6 pb-0" cols="6">
              <h1>Associar nota</h1>
            </v-col>
            <v-col v-show="infoShow" class="text-left px-6 py-0" cols="12">
              <v-alert dense text type="warning">
                Para associar a nota cadastrada clique em salvar.
              </v-alert>
            </v-col>
            <v-col v-show="!showForm && !infoShow" class="text-right px-6 pb-0 pt-2" cols="6">
              <v-btn
                small
                height="30px"
                color="primary"
                depressed
                outlined
                @click="init()"
              >
                Adicionar nota
              </v-btn>
            </v-col>
            <v-col v-show="!showForm" class="px-5 py-1" cols="12" md="6">
              <v-checkbox
                class="pa-0 ma-0"
                v-model="filter"
                label="associadas"
                hide-details
                @change="filterList(listNota)"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="py-0">
          <v-col v-show="showForm" class="card-form" cols="12">
              <CadastroForm
                :formData="formData"
                :sendFile="(file) => addFile(file)"
                :validateForm="validateForm"
                :notaFiscalFormValid="notaFiscalFormValid"
              />
          </v-col>
          <v-col v-show="!showForm" class="pa-0" cols="12">
            <NotasCronogramaList
              :list="listNota"
            />
          </v-col>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-col class="text-left px-4 pt-0" cols="12" sm="6" md="6">
              <v-btn
                v-if="!showForm || list.length == 0"
                small
                height="30px"
                color="primary"
                depressed
                outlined
                @click="showClose()"
              >
                Cancelar
              </v-btn>
              <v-btn
                v-if="showForm && list.length > 0"
                small
                height="30px"
                color="primary"
                depressed
                outlined
                @click="wip();showForm = false"
              >
                Cancelar
              </v-btn>
            </v-col>
            <v-col class="text-right px-4 pt-0" cols="12" sm="6" md="6">
              <v-btn
                v-if="!showForm"
                color="primary"
                small
                height="30px"
                depressed
                @click="saveList(listNota)"
              >
                Salvar
              </v-btn>
              <v-btn
                v-if="showForm"
                color="primary"
                small
                height="30px"
                depressed
                @click="saveForm(formData, file)"
              >
                Salvar
              </v-btn>
            </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from "vuex"
import CadastroForm from './CadastroForm'
import NotasCronogramaList from './NotasCronogramaList'
export default {
  components: {
    CadastroForm,
    NotasCronogramaList
  },
  data() {
    return {
      modalShow: false,
      showForm: false,
      infoShow: false,
      filter: false,
      formData: {
        id: null,  
        numero: null,
        dt_emissao: null,
        valor: 0.00,
        link: null,
        anexo: null,
        is_associado: true
      },
      file: null,
      listNota: [],
      validateForm: false,
      notaFiscalFormValid: {isValid: true},
      numeroNota: null
    };
  },
  computed:{
    ...mapState({
      grupoEconomico: state => state.permissions.grupoEconomico,
      userData: (state) => state.userData.userData,
    })
  },
  watch: {
    dialog(val) {
      this.modalShow = val
    },
    list(val) {
      if (val.length==0) {
        this.showForm = true
      } else {
        this.listNota = val
        this.showForm = false
      }
    }
  },
  methods: {
    showClose() {
      this.infoShow = false 
      this.wip()
      this.sendForm(null)
    },  
    wip() {
      this.formData = {
        id: null,
        numero: null,
        dt_emissao: null,
        valor: 0.00,
        link: null,
        anexo: null,
      }
      this.file = null
    },
    init() {
      this.showForm = true
      this.formData = {
        id: null,
        numero: null,
        dt_emissao: null,
        valor: 0.00,
        link: null,
        anexo: null,
        is_associado: true
      }
      this.file = null
    },  
    addFile(file) { 
      this.file = file 
    },
    saveList(list_nota) {
      this.infoShow = false
      let list = list_nota
      let listNota = list.reduce((arr, item) => {
        item.is_associado = item.is_associado == true ?1 :0
        if (item) { arr.push(item) }
        return arr
      },[])
      this.sendForm(listNota)
    },
    saveForm(formData, file) {
      this.validateForm = true
      this.$nextTick(()=> {
        if(!this.notaFiscalFormValid.isValid) {
          this.validateForm = false
          return
        } 
        this.numeroNota = formData.numero
        formData.grupo_economico = this.grupoEconomico
        formData.cronograma_id = this.cronogramaId
        let payload = JSON.stringify(formData)
        var data = new FormData();
        data.append('Modulo', 'Faturamento');
        data.append('Acao', "addnotafiscal");
        data.append('Payload', payload);
        data.append('File', file);

        this.$store.dispatch("request/sendFile", data).then((response) => {
          if (!response || response.isAxiosError || !response.sucesso) {
            this.$store.commit("hideLoader");
            return;
          } 
          formData.id = Number(response.id)
          let paramModal = {
            type: "success",
            title: "Sucesso!",
            message: response.mensagem,
            callback: () => {
              this.filter = false
              this.showForm = false
              this.infoShow = true 
              let list = this.list
              list.push(formData)
              this.listNota = list
            },
            btConfirm: { name: "Ok", show: true },
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        })
        this.validateForm = false
      })
    },
    filterList(filter) {
      if (this.filter) {
        let list = filter.reduce((arr, item) => {
          let Filter = item.is_associado == true ?item :null
          if (Filter) { arr.push(Filter) }
          return arr
        },[])
        this.listNota = list
      } else {
        this.listNota = this.list
      }
    },
  },
  props: {
    dialog: Boolean,
    list: Array,
    sendForm: Function,
    cronogramaId: String
  },
};
</script>

<style scoped>
.card-form {
  padding: 0 130px;
}
@media (max-width: 869px) {
  .card-form {
    padding: 0;
  }
}
td.text-center.mask {
    width: 130px;
}
input.v-money.pa-0.ma-0 {
    width: 100px;
}
</style>